import {
    DELETE_RESPONSEFORM_REQUEST,
    DELETE_RESPONSEFORM_SUCCESS,
    DELETE_RESPONSEFORM_FAILURE,
  } from "../Types";
  
  const initialState = {
    loading: false,
    error: null,
    message: null, 
  };
  
  const DeletResponseFormReducer = (state = initialState, action) => {
    switch (action.type) {
      case DELETE_RESPONSEFORM_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
          message: null,
        };
  
      case DELETE_RESPONSEFORM_SUCCESS:
        return {
          ...state,
          loading: false,
          message: action.payload.message || "Réponse supprimé avec succès",
        };
  
      case DELETE_RESPONSEFORM_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      default:
        return state;
    }
  };
  
  export default DeletResponseFormReducer;
 